import { useState } from 'react';
import _ from 'lodash';
import CircularProgress from '../components/CircularProgress/CircularProgress';
import Loader from './Loader';
import styles from './FooterButton.module.scss'

export default function FooterButton(props) {
  const {
    id,
    cardType,
    title,
    clickFunction,
    showModalFunction,
    loading = false,
    alt,
    icon,
    inPreview,
    isDisabled,
    isDisabledCallback,
    parentClassName = "",
    loadingOverText,
    parentDivStyle = {},
    iconProps = {},
    hoverComponent,
    active
  } = props;

  function handleClickEvent(e) {
    if (_.isFunction(clickFunction)) {
      clickFunction(e);
    } else if (_.isFunction(showModalFunction)) {
      showModalFunction(true);
    }
  }

  const Icon = icon;

  const style = {
    fontSize: '0.75rem',
    color : active ? "#ffffff": ""
  };

  if (!props.footerButton) return <></>;

  return (
    <li title={title} className={`${parentClassName}${active ? ` ${styles.active}` : ''}`} id={id}>
      <div
        role="button"
        onClick={isDisabled ? isDisabledCallback : handleClickEvent}
        className={`text-light d-flex flex-column justify-content-center align-items-center ${styles.parentComponent} ${
          isDisabled ? 'opacity-50' : ''
        }`}
        style={parentDivStyle}>
        {!loading && Icon && <Icon {...iconProps}/>}
        {loading && (
          <div style={{ width: 24, height: 24, position: 'relative' }}>
            <Loader loading size={14} thickness={1} />
          </div>
        )}

        <div className="text-center text-nowrap" style={style}>
          {loadingOverText ? (
            <div style={{ width: 24, height: 20, position: 'relative' }}>
              <Loader
                loading
                size={14}
                thickness={1}
                borderColor="#2D3136 transparent #2D3136 #2D3136"
              />
            </div>
          ) : (
            props.title
          )}
        </div>

        {hoverComponent ? <div className={styles.hoverComponent}>{hoverComponent}</div>: null}

      </div>
    </li>
  );
}
